import type { WeakValidationMap } from 'react';
import React from 'react';
import { describe } from '@elliemae/ds-props-helpers';
import { useComboBox } from './config/useComboBox.js';
import { Container } from './parts/container/index.js';
import { ComboBoxContext } from './ComboBoxCTX.js';
import type { DSComboboxT } from './react-desc-prop-types.js';
import { ComboboxPropTypes } from './react-desc-prop-types.js';
import { Announcer } from './parts/LiveRegion.js';

export const offScreenStyle: React.CSSProperties = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  width: '1px',
  position: 'absolute',
};

const DSComboBox: React.ComponentType<DSComboboxT.Props> = (props) => {
  const ctx = useComboBox(props);
  return (
    <ComboBoxContext.Provider value={ctx}>
      <Container />
      <Announcer message={props.isLoading || props.isSkeleton ? 'Loading options please wait' : ''} />
    </ComboBoxContext.Provider>
  );
};

DSComboBox.displayName = 'DSComboBox';
const DSComboBoxWithSchema = describe(DSComboBox);

DSComboBoxWithSchema.propTypes = ComboboxPropTypes as WeakValidationMap<unknown>;

export { DSComboBox, DSComboBoxWithSchema, DSComboBox as DSComboBoxV3 };
